import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 1V15",
  "stroke-width": "3",
  "stroke-linecap": "square",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13 8H1",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13 1V15",
  "stroke-width": "3",
  "stroke-linecap": "square",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.4986 7.87313C17.0208 8.15003 16.8579 8.76188 17.1348 9.23974C17.4117 9.71759 18.0235 9.8805 18.5014 9.6036L17.4986 7.87313ZM21 7H22C22 6.64245 21.8091 6.31211 21.4993 6.13358C21.1895 5.95505 20.808 5.9555 20.4986 6.13476L21 7ZM20 17V18H22V17H20ZM18.5014 9.6036L21.5014 7.86524L20.4986 6.13476L17.4986 7.87313L18.5014 9.6036ZM20 7V17H22V7H20Z",
  fill: "var(--light-gray)",
  "stroke-width": "1"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ], 64))
}